import { SHEET_DISCIPLINES } from "./sheetNavigation";

// Suggest a drawing's sheet number and title from the text on its page — the title block is normally bottom-right, and the
// number is the token next to a "SHEET NO." / "DWG NO." label. This is a SUGGESTION: the page gallery shows it editable and
// nothing is saved until the person adds the page. Pure; takes the items pdfRender.extractPageText returns.
//   items: [{ str, x, y }]  (x, y = top-left in page points, y down)    page: { width, height }
//   -> { number, title, discipline, confidence: 'high' | 'low' | 'none' }

const NUMBER_RE = /^([A-Z]{1,3})[-.]?(\d{1,3}(?:\.\d{1,3})?[A-Z]?)$/;
const LABEL_RE = /\b(SHEET\s*(NO|NUMBER|#)|DWG\.?\s*(NO|#)|DRAWING\s*(NO|NUMBER|#))\b/i;
const NOT_TITLE_RE = /\b(SHEET|DATE|SCALE|DRAWN|CHECKED|PROJECT|JOB|REVISION|REV|ISSUE|NO\.?|NUMBER|SEAL|ARCHITECT|ENGINEER|COPYRIGHT)\b/i;

const normNumber = (letters, rest) => `${letters}-${rest}`;
export const disciplineOfNumber = (number) => {
  const letters = /^([A-Z]+)/.exec(String(number || "").toUpperCase())?.[1] || "";
  return SHEET_DISCIPLINES.find(d => d.prefixes.includes(letters))?.key || SHEET_DISCIPLINES.find(d => letters.length > 1 && d.prefixes.includes(letters[0]))?.key || null;
};

export function detectSheetId(items = [], page = { width: 0, height: 0 }) {
  const W = page.width || 1, H = page.height || 1;
  const labels = items.filter(i => LABEL_RE.test(i.str));
  let best = null;
  for (const it of items) {
    for (const raw of String(it.str).toUpperCase().split(/[\s,;:]+/)) {
      const m = NUMBER_RE.exec(raw);
      if (!m) continue;
      let score = 0;
      const fx = it.x / W, fy = it.y / H;
      if (fx > 0.55 && fy > 0.6) score += 3;
      if (fx > 0.7 && fy > 0.8) score += 2;
      if (labels.some(l => Math.abs(l.x - it.x) < 120 && it.y - l.y > -10 && it.y - l.y < 70)) score += 4;
      if (m[2].includes(".") || m[2].length >= 2) score += 1;      // "A-101" / "M-2.01" over "A-1"
      if (!best || score > best.score) best = { score, number: normNumber(m[1], m[2]) };
    }
  }
  if (!best || best.score < 3) return { number: null, title: null, discipline: null, confidence: "none" };

  // title: the longest multi-word line in the title-block corner that is not a label
  const region = items.filter(i => i.x / W > 0.55 && i.y / H > 0.6);
  const titleItem = region
    .filter(i => { const t = String(i.str).trim(); return t.length >= 6 && /\s/.test(t) && /[A-Za-z]{3}/.test(t) && !NOT_TITLE_RE.test(t); })
    .sort((a, b) => String(b.str).length - String(a.str).length)[0];
  const title = titleItem ? String(titleItem.str).trim().replace(/\s+/g, " ").slice(0, 80) : null;
  return { number: best.number, title, discipline: disciplineOfNumber(best.number), confidence: best.score >= 5 ? "high" : "low" };
}
